import { env } from "../../react/features/base/environment/utils";
export const authDomain = env("AUTH_DOMAIN");
export const URL_POLICY = env("URL_POLICY") || "https://viettelmeet.com/documents/204/dieu-khoan-chinh-sach";
export const DOMAIN_MEETING = env("DOMAIN") || "https://testmeeting.atviettelsolutions.com";
const domain = `${authDomain}/`;
const API_DOMAIN = authDomain + "/vmp/";
export const API_WHITEBOARD = domain + "api/whiteboard/v1.0/whiteboards";
export const PAGE_AUTH = authDomain;
export const API_GUEST_UPDATE_NAME = domain + "vmp/guest-update-name";
export const API_JOIN_GUEST = domain + "vmp/guest-join";
export const API_VMP_GET_USER_BY_TOKEN = domain + "vmp/get-user-token";
export const API_VMP_LOGOUT = domain + "vmp/auth/logout";
export const API_MAP = {
    AUTH: {
        REFRESH_TOKEN: API_DOMAIN + "auth/refresh",
        VPQH_SSO: API_DOMAIN + "sso/vpqh",
        SSO: API_DOMAIN + "sso"
    },
    ROOM: {
        CHECK_LIMITED_USER: API_DOMAIN + 'checkLimitedUser',
        GET_TOTAL_USERS: API_DOMAIN + 'rooms/get-total-users',
        GET_TOTAL_MEETING: API_DOMAIN + "v1.2/rooms/total-meeting-progress",
        GET_ROLE_ROOM: API_DOMAIN + "rooms/action/get-role-user",
        CHECK_LIMIT_MEETING: API_DOMAIN + "v1.2/rooms/check-limit-meeting",
        GET_LIMIT_USERS: API_DOMAIN + "rooms/action/get-limit-user",
        UPDATE_PASSWORD: API_DOMAIN + "v1.2/rooms/update-password"
    },
    USER: {
        CHECK_GUEST_ACCOUNT: API_DOMAIN + 'check-guest',
        UPDATE_DISPLAYNAME: API_DOMAIN + 'update-displayName',
        GET_USER_FUNCTIONS: API_DOMAIN + 'functions/get/user-functions'
    },
    WHITEBOARD: {
        GET_TOTAL: API_WHITEBOARD + '/get/total'
    }
};
